{
	"pixKeyLabel": "Clave PIX",
	"pixTypeLabel": "Tipo de clave PIX",
	"pixTypePlaceholder": "Seleccione el tipo de clave PIX",
	"pixKeyType": {
		"random": "Aleatorio",
		"phone": "Teléfone",
		"copyPaste": "Copiar y Pegar"
	},
	"validation": {
		"invalidPixKey": "Clave pix no válida"
	}
}
